module.exports = __webpack_public_path__ + "img/login_icon.35c5b0d3.png";